<template>
  <NotificationContainer :show="props.show">
    <div class="flex items-center">
      <div class="flex w-0 flex-1 justify-between">
        <ParagraphText
          font="font-medium"
          color="text-gray-900"
          class="w-0 flex-1"
        >
          <slot />
        </ParagraphText>
        <slot name="after" />
      </div>
      <div class="ml-4 flex flex-shrink-0">
        <ButtonXIcon @click="emit('close')" />
      </div>
    </div>
  </NotificationContainer>
</template>

<script setup>
import ButtonXIcon from '@/Common/Elements/Buttons/ButtonXIcon.vue'
import NotificationContainer from './NotificationContainer.vue'
import ParagraphText from '@/Common/Text/ParagraphText.vue'

const props = defineProps({
  show: Boolean,
})

const emit = defineEmits(['close'])
</script>
